/**
 * A pickup with no day yet (T-175).
 *
 * Staff often set a case to pickup before the family knows when they'll come.
 * That is a valid, saveable state: a pickup sends the family nothing until a day
 * is set (no "choose your delivery" invite, no ship day, no label), so the
 * only thing that could go wrong is staff forgetting to ask. These cases
 * therefore collect at the top of the deliveries page.
 */
import { CremationStatus, Funeral } from '../types';

/** What the editor shows in place of a day. */
export const PICKUP_DATE_TBD = 'Date to be confirmed';

/** The compact form, for lists. */
export const PICKUP_TBD_LABEL = 'Pickup · date TBD';

/** `pickup` is the legacy method some older rows still carry. */
export const isPickupMethod = (method?: string | null): boolean =>
  method === 'office_pickup' || method === 'crematorium_pickup' || method === 'pickup';

/** A pickup on a case whose ashes are ready or scheduled, with no day set. */
export const pickupNeedsDate = (funeral: {
  delivery_method?: Funeral['delivery_method'] | string;
  delivery_day?: string | null;
  cremation_status?: string | null;
  delivered_at?: string | null;
}): boolean =>
  isPickupMethod(funeral.delivery_method) &&
  !funeral.delivery_day &&
  !funeral.delivered_at &&
  (funeral.cremation_status === CremationStatus.READY_FOR_DELIVERY ||
    funeral.cremation_status === CremationStatus.DELIVERY_SCHEDULED);
